import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setHideNemsisCustomOption, setNemsisCustomStateDataOptions } from '../store/options.actions'
import { IConfigurationsState } from '../../configurations/store/configurations.types'
import { getConfigurationsSelector } from '../../configurations/selectors'
import { IStateCustomElements } from '../../nemsisData/store/nemsisCustomData.types'

export function* getAllStateCustomData() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getStateCustomElements])
    const { datasetDeterminationConfig }: IConfigurationsState = yield select(getConfigurationsSelector)
    const supportedStates = datasetDeterminationConfig?.datasets
      ?.filter((item) => item?.isStateSupportedInNOW === 1)
      .map((item) => item?.dataset)
    const entity = (response?.entity as IStateCustomElements) || []
    const hideNemsisCustomOption = !entity?.some((e) => supportedStates?.includes(e.state))
    yield put(setNemsisCustomStateDataOptions(entity))
    yield put(setHideNemsisCustomOption(hideNemsisCustomOption))
  } catch (e) {
    yield put(throwPcrException(`setStateCustomElements() error while fetching state custom elements: ${e}`))
  }
}

export function* getAllStateCustomDataSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getAllStateCustomData)
}
